export default __webpack_public_path__ + "static/media/center_management.ca92f84a.svg";